import React from 'react';

const AlertBosnia = () => {
     
 return <>
            <h1>Obavještenje o AKCIJI!</h1>
            <p>Cijena jednog parfema iznosi:  <b>24,00KM</b></p>
            <p>Ukoliko odaberete <b>2 parfema</b>, parfem će vas koštati <b>20,00KM</b> </p>
            <p>U korpi će vam odmah biti izračunato u zavisnosti od toga koliko ste parfema odabrali.</p>
            <h2>Napomena !</h2>
            <h3>Garantujemo za kvalitet, u suprotnom vraćamo ukupan iznos novca kao i troškove dostave.</h3>
        </>
}

export default AlertBosnia;